// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3cvKB","amount":"Amount_amount__3TKR3","tip":"Amount_tip__1TVEZ","tipHeader":"Amount_tipHeader__UOHKg","tipsWrap":"Amount_tipsWrap__ij9vX"};